module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#technology",
      toString: function () {
        return this.url;
      }
    }